module.exports = __webpack_public_path__ + "static/img/cp.0d050627.jpg";